// theme.js
export const Breakpoints = ["40em", "52em", "64em", "80em"]
